module.exports = __webpack_public_path__ + "static/media/spoon.0959b979.jpg";